<template>
  <div class="order-box">
    <el-form inline class="elForm">
      <el-form-item label="订单号">
        <el-input placeholder="订单号" v-model="form.childOrderNo"></el-input>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select v-model="form.status" placeholder="请选择">
          <el-option :value="-1" label="全部"></el-option>
          <el-option :value="10" label="待付款"></el-option>
          <el-option :value="20" label="备货中"></el-option>
          <el-option :value="30" label="待收货"></el-option>
          <el-option :value="40" label="已收货"></el-option>
          <el-option :value="50" label="已完成"></el-option>
          <el-option :value="60" label="已取消"></el-option>
          <el-option :value="70" label="已关闭"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input placeholder="商品名称" v-model="form.proName"></el-input>
      </el-form-item>
      <el-form-item label="收货人">
        <el-input placeholder="收货人" v-model="form.receiverName"></el-input>
      </el-form-item>
      <el-form-item label="收货人手机">
        <el-input placeholder="收货人手机" type="number" v-model="form.receiverPhone"></el-input>
      </el-form-item>
      <el-form-item label="收货省">
        <el-select v-model="form.receiverProvinceName" placeholder="请选择" @change="handleProvince">
          <el-option v-for="item in provinceList" :key="item.value" :label="item.AreaName" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="收货市">
        <el-select v-model="form.receiverCityName" placeholder="请选择" @change="handleCity">
          <el-option v-for="item in cityList" :key="item.value" :label="item.AreaName" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付时间">
        <el-date-picker v-model="timeValue" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"></el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="search">搜索</el-button>
      <el-button type="primary" plain @click="reset">重置</el-button>
      <el-button type="danger" plain @click="handleImport">批量导入</el-button>
    </el-form>
    <el-table border :data="orderList" :header-cell-style="{ background: '#F3F3F3' }" id="act-set-table">
      <el-table-column label="订单号" prop="ChildOrderNo" align="center"></el-table-column>
      <el-table-column label="状态" prop="" align="center" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.Status == 10">待支付</span>
          <span v-if="scope.row.Status == 20">备货中</span>
          <span v-if="scope.row.Status == 30">待收货</span>
          <span v-if="scope.row.Status == 40">已收货</span>
          <span v-if="scope.row.Status == 50">已完成</span>
          <span v-if="scope.row.Status == 60">已取消</span>
          <span v-if="scope.row.Status == 70">已关闭</span>
        </template>
      </el-table-column>
      <el-table-column label="商品名称" prop="ProName" align="center"></el-table-column>
      <el-table-column label="采购方" prop="SupplierName" align="center"></el-table-column>
      <el-table-column label="下单数量" prop="" align="center">
        <template slot-scope="scope">
          <p>下单数量：{{ scope.row.SkuNumber }}</p>
          <p style="font-weight:700">退款完成数量：<span style="color:red;">{{ scope.row.RefundNum }}</span></p>
          <p style="font-weight:700">退款进行中数量：<span style="color:red;">{{ scope.row.RefundNumIng }}</span></p>
        </template>
      </el-table-column>
      <el-table-column label="规格" prop="SkuSpecs" align="center" width="100"></el-table-column>
      <el-table-column label="收货信息" prop="" align="center">
        <template slot-scope="scope">
          <p>{{ scope.row.ReceiverName }} {{ scope.row.ReceiverPhone }}</p>
          <p>{{ scope.row.ReceiverProvinceName }} {{ scope.row.ReceiverCityName }} {{ scope.row.ReceiverDistrictName }} {{ scope.row.ReceiverStreetName }} {{ scope.row.ReceiverAddress }} </p>
        </template>
      </el-table-column>
      <el-table-column label="物流信息" prop="" align="center">
        <template slot-scope="scope">
          <div v-for="(item, i) in scope.row.logisticInfos" :key="i">
            <span>{{ item.LogisticsCode }} </span>
            <span>（{{ item.SendSkuNumer }} 台）</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" prop="" align="center">
        <template slot-scope="scope">
          {{ scope.row.PayTime.split(' ')[0] }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="300">
        <template slot-scope="scope">
          <el-form >
            <el-form-item style="margin-bottom:5px;">
              <el-select v-model="scope.row.logisticsCompanyId" filterable remote reserve-keyword placeholder="请选择物流公司"
                :remote-method="remoteMethod" :loading="loading" style="width:140px" size="small">
                <el-option v-for="item in deliveryList" :key="item.Id" :label="item.ShortName" :value="item.Id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:5px;">
              <el-input placeholder="单号(自动查询物流公司)" v-model="scope.row.logisticsCode" size="small" style="width:200px;"
                @blur="((val) => { change(val, scope.$index) })"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:0;">
              <el-input placeholder="数量" size="small" style="width:100px;" type="number"
                v-model="scope.row.sendSkuNumber"></el-input>
              <el-button type="primary" size="small" @click="send(scope.row)" style="margin-left:5px;">发货</el-button>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"
      @current-change="handleCurrentChange" style="margin-top:20px;padding-bottom:20px;"></el-pagination>
    <!-- 上传文件弹窗 -->
    <el-dialog title="导入物流信息" width="30%" :visible.sync="logisticsVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo">下载导入模板</el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleExpSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetOrderList, AreaList, GetDeliveryList, GetLogisticsByNumber, ChildSupShip, OrderLogisticsImport
} from '../../api/api'
export default {
  name: 'order',
  data() {
    return {
      form: {
        childOrderNo: null,
        status: 20,
        proName: null,
        receiverName: null,
        receiverPhone: null,
        receiverProvinceName: null,
        receiverCityName: null,
        startPayTime: null,
        endPayTime: null,
        pageIndex: 1,
        pageSize: 10
      },
      provinceId: null,
      cityId: null,
      timeValue: null,
      orderList: [],
      total: 0,

      provinceList: [],
      cityList: [],

      deliveryList: [],
      loading: false,

      logisticsVisible: false,
      uploading: false,
      fileLog: null
    }
  },
  created() {
    this.getList()
    this.getProvinceList()
    this.getDeliverys('')
  },
  methods: {
    getList() {
      GetOrderList(this.form).then(res => {
        if (res.data.success) {
          let list = res.data.response.data || []
          list.forEach(i => {
            i.logisticsCompanyId = null
            i.logisticsCode = null
            i.sendSkuNumber = null
          })
          this.orderList = list
          this.total = res.data.response.dataCount
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val;
      this.getList();
    },
    handleSizeChange(e) {
      this.form.pageSize = e;
      this.getList();
    },
    search() {
      this.form.pageIndex = 1
      this.getList()
    },
    reset() {
      this.form = {
        childOrderNo: null,
        status: -1,
        proName: null,
        receiverName: null,
        receiverPhone: null,
        receiverProvinceName: null,
        receiverCityName: null,
        startPayTime: null,
        endPayTime: null,
        pageIndex: 1,
        pageSize: 10
      }
      this.provinceId = null
      this.cityId = null
      this.timeValue = null
      this.getList()
    },
    handlePicker(e) {
      if (e) {
        this.form.startPayTime = e[0];
        this.form.endPayTime = e[1];
      } else {
        this.form.startPayTime = null
        this.form.endPayTime = null
      }
    },
    getProvinceList() {
      let params = {
        areaLevel: 1
      }
      AreaList(params).then(res => {
        if (res.data.success) {
          this.provinceList = res.data.response.data;
        }
      })
    },
    getCityList() {
      let params = {
        parentId: this.provinceId
      }
      AreaList(params).then(res => {
        if (res.data.success) {
          this.cityList = res.data.response.data;
        }
      })
    },
    handleProvince(val) {
      this.provinceId = val.Id
      this.form.receiverProvinceName = val.AreaName
      this.cityId = null
      this.form.receiverCityName = ''
      this.getCityList()
    },
    handleCity(val) {
      this.cityId = val.Id
      this.form.receiverCityName = val.AreaName
    },
    getDeliverys(query, cb) {
      GetDeliveryList({ SearchKey: query }).then(res => {
        if (res.data.success) {
          this.deliveryList = res.data.response
        } else {
          this.$message.error(res.data.msg)
        }
        cb && cb()
      })
    },
    change(e, index) {
      GetLogisticsByNumber({ code: e.target.value }).then(res => {
        if (res.data.success) {
          this.$set(this.orderList[index], 'logisticsCompanyId', res.data.response.Id)
        }
      })
    },
    remoteMethod(query) {
      if (this.st) clearTimeout(this.st)
      this.st = setTimeout(() => {
        this.loading = true;
        this.getDeliverys(query, () => {
          this.loading = false;
        })
      }, 300)
    },
    send(data) {
      if (!data.logisticsCompanyId || !data.logisticsCode || !data.sendSkuNumber) return this.$message.error('请填写完整发货信息')
      ChildSupShip({
        "childOrderId": data.ChildOrderId,
        "buySupplierId": data.SupplierId,
        "logisticsCompanyId": data.logisticsCompanyId,
        "sendSkuNumber": data.sendSkuNumber,
        "logisticsCode": data.logisticsCode,
        // "outChildOrderNo": ""
      }).then(res => {
        if (res.data.success) {
          this.$message.success('发货成功')
          this.getList()
        } else {
          this.$message.success(res.data.msg)
        }
      })
    },
    handleImport() {
      this.logisticsVisible = true;
    },
    upDataInfo(index) {
      window.open(
        "https://ksaximg.ksaxshop.com/admin/%E7%89%A9%E6%B5%81%E6%A8%A1%E6%9D%BF.xlsx"
      );
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    handleExpSubmit(index) {
      let that = this;
      that.uploading = true;
      let formData = new window.FormData();
      formData.append("formFile", that.filePur);
      OrderLogisticsImport(formData).then((res) => {
        if (res.data.success) {
          that.$message.success(res.data.msg);
          that.uploading = false;
          that.logisticsVisible = false;
          that.getList();
        } else {
          that.$message.error(res.data.msg);
          that.uploading = false;
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.order-box {
  width: 95%;
  margin: 0 auto;
  padding-top: 30px;
}

.main-top {
  display: flex;
  height: 204px;
  margin-bottom: 20px;

  .portrait-box {
    width: 204px;
    background: linear-gradient(90deg, #F73446 0%, #FB6035 100%);
    border-radius: 10px 0px 0px 10px;
    text-align: center;
    padding: 24px 0;

    .portrait {
      width: 80px;
      height: 80px;
      display: inline-block;
      border-radius: 40px;
      background: #fff;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        border-radius: 40px;
      }
    }

    .user-name {
      font-size: 18px;
      line-height: 28px;
      color: #fff;
      margin: 10px 0;
    }

    .user-info {
      color: #fff;
      font-size: 14px;

      span {
        padding: 3px 5px;
        border-radius: 12px;
        border: 1px solid #ffffff;
      }
    }
  }

  .wallet-box {
    flex: 1;
    width: 736px;
    background: #fff;
    border-radius: 0 10px 10px 0;
    text-align: left;

    .wallet {
      padding-left: 16px;
      border-bottom: 1px solid #f4f4f4;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      color: #333;
    }

    .money-box {
      // padding-left: 16px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 153px;

      span {
        display: block;
      }

      .txt-bold {
        font-size: 24px;
        color: #474245;
      }

      .txt999 {
        color: #999;
      }
    }
  }
}

.elForm {
  text-align: left;
}
</style>